import type React from 'react';

import useBannerOffset from 'hooks/useBannerOffset';
import * as Styled from './Wrapper.styled';

interface WrapperProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component for AgentWizard screens that handles banner offset
 */
export const Wrapper: React.FC<WrapperProps> = ({ children, className }) => {
  const bannerOffset = useBannerOffset();

  return (
    <Styled.Wrapper $bannerOffset={bannerOffset} className={className}>
      {children}
    </Styled.Wrapper>
  );
};
